import { PAYMENT_SERVICE_BASE_URL } from "@/data/urls";
import { TPlanCurrentInterval } from "@/types/app";
import axios from "axios";

const APIURL = `${PAYMENT_SERVICE_BASE_URL}/plan/modify-interval`;

export const changePlanInterval = async ({
  token,
  interval,
  couponValue,
  ...rest
}: {
  token: string;
  interval: TPlanCurrentInterval;
  creatorId?: string;
  couponValue?: string;
}) => {
  try {
    const res = await axios.post(
      APIURL,
      {
        request_type: "charge",
        change_to: interval,
        ...(couponValue && { coupon_code: couponValue }),
        ...(rest.creatorId && {
          marketplace_offer: rest.creatorId,
        }),
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      },
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
